import API from "./api";

const DashboardService = {
    // Get all dashboard statistics
    getStats: async () => {
        try {
            // So just use "/admin/dashboard/stats" (without /backend)
            const response = await API.get("/admin/dashboard/stats");
            return response.data;
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
            throw error;
        }
    }
};

export default DashboardService;